module.exports = __webpack_public_path__ + "img/campus_event_bn.28275c3c.png";